module.exports = __webpack_public_path__ + "media/event_wildfire.2794f79c.mp3";